module.exports = __webpack_public_path__ + "assets/img/banner.58284f5b.png";